import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import NewLandingProduct from "areas/landing/elements/landing-product/new-landing-product"
import Image from "components/landing/image"
import Textarea from "components/landing/textarea"
import { getUrlProps } from "helpers/landing"

const ColumnBlock = ({ column, element, lazyload }) => {
  return (
    <Box
      aria-label={column.aria_label}
      display="block"
      {...getUrlProps(
        column.url,
        column.link_id || element?.anchor_name || element?.id
      )}
    >
      {column.components.map((component, index) => {
        if (component.type === "product") {
          return (
            <NewLandingProduct
              element={element}
              hide_metal_selector={element.style?.hide_metal_selector}
              index={index}
              key={`${component.id}-${index}`}
              product={component}
              productWrapperStyle={{ mb: 0 }}
              show_prices={element.show_prices}
            />
          )
        } else if (component.image) {
          return (
            <Image
              image={component.image}
              key={`${component.id}-${index}`}
              lazyload={lazyload}
            />
          )
        } else if (component.textarea) {
          return (
            <Textarea
              element={component.textarea}
              key={`${component.id}-${index}`}
              linkClickData={element?.anchor_name || element?.id}
              style={component.textarea.style}
            />
          )
        }
      })}
    </Box>
  )
}

ColumnBlock.propTypes = {
  column: PropTypes.object,
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default ColumnBlock
